import React, { Component } from 'react'
import GoogleTagManager from 'gtm'

import MenuOffCanvas from 'components/MenuOffCanvas'
import Header from 'components/Header'
import LayerHeader from 'components/LayerHeader'
import ContentContainer from 'modules/Content/ContentContainer'
import Footer from 'components/Footer'

import SelectedRegionController from 'modules/Controllers/SelectedRegion/SelectedRegionController'
import SurveyControllerContainer from 'modules/Controllers/Survey/SurveyControllerContainer'
import HTMLTitleController from 'modules/Controllers/HTMLTitle/HTMLTitleController'

class IndicatorsPerformance extends Component {
  render() {
    return (
      <div className="App">
        <GoogleTagManager gtmId="GTM-NXH8F9G" />
        <SelectedRegionController />
        <SurveyControllerContainer />
        <MenuOffCanvas />
        <Header />
        <LayerHeader />
        <ContentContainer />
        <Footer />
        <HTMLTitleController />
      </div>
    )
  }
}

export default IndicatorsPerformance



// WEBPACK FOOTER //
// ./src/pages/IndicatorsPerformance/IndicatorsPerformance.jsx